import Vue from 'vue'
import App from '@/App.vue'
import router from '@/router'
import store from '@/store'

import PortalVue from 'portal-vue'
import VueHttp from './plugin/VueHttp'
import VueUtils from './plugin/VueUtils'
import VueHead from 'vue-head'
import VueLazyLoad from 'vue-lazyload'
import VueClipboard from 'vue-clipboard2'

Vue.use(PortalVue)
Vue.use(VueHttp, { store, router })
Vue.use(VueUtils)
Vue.use(VueHead)
Vue.use(VueLazyLoad, {
  lazyComponent: true,
  observer: true,
})
Vue.use(VueClipboard)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
